<template>
  <ReportStatusTable
    :is-table-locked="isTableLocked"
    :loading="loading"
    :per-page="perPage"
    :table-data="historyData"
    :total-records="totalRecords"
    @on-page="onPage($event)"
    @on-sort="onSort($event)"
  />
</template>

<script>
//Vuex
import { mapActions, mapGetters } from 'vuex'
// Components
import ReportStatusTable from '@/pages/your-reports/components/ReportStatusTable'
// Utils
import { formatDate } from '@/utils/format-date'
import { trancateString } from '@/utils/text-formatter'
import { copyText } from '@/utils/copy-text'
import { scrollToSelector } from '@/utils/scroll-to'
import { PLANS_HISTORY_AVAILABLE } from '@/utils/plans'
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'ReportHistoryTable',
  components: {
    ReportStatusTable,
  },
  mixins: [deviceWidthMixin],
  props: {
    isPaymentHistoryOpen: {
      type: Boolean,
      default: false,
    },
    rowsPerPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      loading: false,
      pagesOptions: [5, 10, 20, 50, 100],
      perPage: 5,
      historyData: [],
      totalRecords: 0,
      lazyParams: {},
    }
  },
  computed: {
    ...mapGetters('subscribe', [
      'getSubscriptionPeriodEnded',
      'hasBillingIssue',
    ]),
    ...mapGetters('payment', ['getCurrentPlan']),
    headerHeight() {
      return getComputedStyle(document.documentElement).getPropertyValue(
        '--header-height',
      )
    },
    isTableLocked() {
      return (
        this.getSubscriptionPeriodEnded ||
        this.hasBillingIssue ||
        !PLANS_HISTORY_AVAILABLE.includes(this.getCurrentPlan.planTier)
      )
    },
  },
  mounted() {
    this.perPage = this.rowsPerPage
    this.lazyParams = {
      pageSize: this.perPage,
      pageNumber: 1,
      sort: {},
    }
    this.loadData()
  },

  methods: {
    ...mapActions({
      getReportsHistoryList: 'report/getReportsHistoryList',
    }),
    trancateString,
    formatDate,
    copyText,
    scrollToSelector,
    scrollToSelectorItem(wrap, aim) {
      this.scrollToSelector(wrap, aim, parseInt(this.headerHeight))
    },
    async loadData() {
      this.loading = true
      await this.getReportsHistoryList({
        lazyParams: this.lazyParams,
      })
        .then(({ success, data }) => {
          if (!success) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error Message',
              detail: data.data.message,
              life: 3000,
            })
          }
          if (data.data.length) {
            this.$emit('isHistoryPresent', true)
          }
          this.totalRecords = data.pagesTotal * data.pageSize
          this.historyData = data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPage(event) {
      this.scrollToSelectorItem('.main', '.sof-main-content-wrapper', 200)
      this.lazyParams.pageSize = event.rows
      this.lazyParams.pageNumber = event.page + 1
      this.loadData()
    },
    onSort(event) {
      this.lazyParams.sort = {}
      if (event.sortField) {
        this.lazyParams.sort[event.sortField] = event.sortOrder
      }
      this.loadData()
    },
  },
}
</script>
